import { render, staticRenderFns } from "./JournalSearch.vue?vue&type=template&id=1ac12032&"
import script from "./JournalSearch.vue?vue&type=script&lang=js&"
export * from "./JournalSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports